import { initializeGraphql } from "./graphql/client";

/**
 * Gets an authentication token from the Office host for the signed-in user.
 * This uses the SSO API which returns an Azure AD token scoped to the add-in.
 */
export async function getOutlookToken(): Promise<string> {
  try {
    const token = await Office.auth.getAccessToken({
      allowSignInPrompt: true,
      allowConsentPrompt: true,
    });
    return token;
  } catch (error) {
    console.error("Failed to get Office SSO token:", error);
    throw error;
  }
}

export function initializeOffice(): Promise<void> {
  return new Promise((resolve) => {
    Office.onReady((info) => {
      if (info.host === Office.HostType.Outlook) {
        console.log("Office.js initialized for Outlook");
      }
      initializeGraphql();
      resolve();
    });
  });
}
